package modysy

import modysy.datastructures.Vector2
import modysy.model.{Agent, GameObject, Obstacle, Portal}
import play.api.libs.json._

object JsonSaver {
  implicit private val vector2Writes = new Writes[Vector2] {
    def writes(vec: Vector2) = {
      Json.arr(vec.x, vec.y)
    }
  }

  implicit private val gameObjectWrites = new Writes[GameObject] {
    def writes(gameObject: GameObject) = {
      if (gameObject.isInstanceOf[Agent]) {
        val agent = gameObject.asInstanceOf[Agent]

        Json.obj(
          "type" -> "agent",
          "position" -> agent.body.pose.translation,
          "state" -> agent.state.name
        )
      } else if (gameObject.isInstanceOf[Obstacle]) {
        val obstacle = gameObject.asInstanceOf[Obstacle]

        Json.obj(
          "type" -> "obstacle",
          "position" -> obstacle.body.pose.translation,
          "orientation" -> obstacle.body.pose.orientation
        )
      } else JsNull
    }
  }

  implicit private val portalPairWrites = new Writes[(Portal, Portal)] {
    def writes(portalPair: (Portal, Portal)) = Json.obj(
      "entrance_x" -> portalPair._1.body.pose.translation.x,
      "entrance_y" -> portalPair._1.body.pose.translation.y,
      "exit_x" -> portalPair._2.body.pose.translation.x,
      "exit_y" -> portalPair._2.body.pose.translation.y
    )
  }

  implicit private val levelWrites = new Writes[Level] {
    def writes(level: Level) = Json.obj(
      "width" -> level.width,
      "height" -> level.height,
      "objects" -> level.objects,
      "portals" -> level.portals
    )
  }

  private def filterNullOut(json: JsValue): JsValue = {
    JsObject(
      json
        .as[JsObject]
        .value
        .map(
          firstLevel =>
            firstLevel match {
              case (name, JsArray(elements)) =>
                (name,
                 JsArray(
                   elements.flatMap {
                     case JsNull => None
                     case other  => Some(other)
                   }
                 ))
              case other => other
          }
        ))
  }

  def toJson(level: Level): JsValue =
    filterNullOut(Json.toJson(level))
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/JsonSaver.scala